import { Routes, Route } from "react-router-dom";
import AuthGuard from "./components/AuthGuard.tsx";
import Layout from "./components/Layout.tsx";
import Login from "./pages/Login.tsx";
import Dashboard from "./pages/Dashboard.tsx";
import ReviewQueue from "./pages/ReviewQueue.tsx";
import FeedBrowse from "./pages/FeedBrowse.tsx";
import Curate from "./pages/Curate.tsx";
import ArticleDetail from "./pages/ArticleDetail.tsx";
import PopoutPreview from "./pages/PopoutPreview.tsx";
import Feeds from "./pages/Feeds.tsx";
import Settings from "./pages/Settings.tsx";
import AuditLog from "./pages/AuditLog.tsx";
import Diagnostics from "./pages/Diagnostics.tsx";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/popout/:id" element={<PopoutPreview />} />
      <Route element={
        <AuthGuard>
          <Layout />
        </AuthGuard>
      }>
        <Route index        element={<Dashboard />} />
        <Route path="review"   element={<ReviewQueue />} />
        <Route path="browse"   element={<FeedBrowse />} />
        <Route path="curate"   element={<Curate />} />
        <Route path="articles/:id" element={<ArticleDetail />} />
        <Route path="feeds"    element={<Feeds />} />
        <Route path="settings" element={<Settings />} />
        <Route path="audit"    element={<AuditLog />} />
        <Route path="diagnostics" element={<Diagnostics />} />
      </Route>
    </Routes>
  );
}